import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-alignbottomsimple",
  "use": "icon-th-alignbottomsimple-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-alignbottomsimple\">\n<path d=\"M26 29C26 29.2652 25.8946 29.5196 25.7071 29.7071C25.5196 29.8946 25.2652 30 25 30H7C6.73478 30 6.48043 29.8946 6.29289 29.7071C6.10536 29.5196 6 29.2652 6 29C6 28.7348 6.10536 28.4804 6.29289 28.2929C6.48043 28.1054 6.73478 28 7 28H25C25.2652 28 25.5196 28.1054 25.7071 28.2929C25.8946 28.4804 26 28.7348 26 29ZM10 24V5C10 4.46957 10.2107 3.96086 10.5858 3.58579C10.9609 3.21071 11.4696 3 12 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H12C11.4696 26 10.9609 25.7893 10.5858 25.4142C10.2107 25.0391 10 24.5304 10 24ZM12 24H20V5H12V24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-alignbottomsimple.svg
// module id = NGyr
// module chunks = 84